import { shouldUseDKFeatures } from '../../../utils/shouldUseDKFeatures'
import { SupportedCountries } from '../types/supportedCountries'

const supportedCountriesArray: SupportedCountries[] = ['DK', 'DE', 'FR', 'NL', 'FO', 'GL']

export const isSupportedCountryId = (country: string | undefined): country is SupportedCountries => {
  return supportedCountriesArray.includes(country as SupportedCountries)
}

export const shouldUseDKReportContent = (country: string | undefined): boolean => shouldUseDKFeatures(country)
